import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import { sidebarToggle } from "./../../utils/toggler.js";
import BottomNavbar from "../BottomNavbar/Index";
import DashboardHeader from "../Other/DashboardHeader";
import HomePage from "../../pages/HomePage.jsx";

function AuthLayout({ ...props }) {
  const isDesktop = () => document.body.clientWidth > 768;
  const [sidebarStatus, setSidebarStatus] = useState("");
  const location = useLocation();
  const showBottomNavbar =
    location.pathname === "/" || location.pathname === "/calendar" || location.pathname === "/home" || location.pathname === "/settings" || location.pathname === "/notifications";

  useEffect(() => {
    window.addEventListener("resize", () => {
      setSidebarStatus(isDesktop());
    });
    return () => window.removeEventListener("resize", isDesktop);
  }, []);

  return (
    <div className="adminLayout">
      {/* Sidebar */}
      <Sidebar
        toggle={sidebarToggle}
        className={sidebarStatus ? "" : "mobile"}
      />

      {/* Main Wrapper */}
     <div className="mainWrapper ">
  {/* Header is rendered by page components (CustomPageHeader), not here */}
        {/* centered page content */}
        <div className="mainCard w-full max-w-4xl h-full">
          <Outlet context={[sidebarToggle]} />
        </div>
      </div>


      {/* Bottom Navigation */}
      {showBottomNavbar && <BottomNavbar />}
    </div>
  );
}

export default AuthLayout;
